import React from 'react'
import { insuranceLayout } from '@/constants/insuranceLayout'
const IconRecoverySealWhite = ({
  insuranceSlug,
  className
}: {
  insuranceSlug?: string
  className?: string
}): JSX.Element => {
  const fillColor =
    (insuranceSlug && insuranceLayout[insuranceSlug]?.color) || '#f0e6f4'
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="42"
      height="41"
      viewBox="0 0 42 41"
      fill="none"
    >
      <g
        filter="url(#filter0_b_11326_519495)"
        fill={fillColor}
      >
        <path
          d="M19.7,1.8c1.3-1,3.2-1,4.6,0l3,2.3c0.6,0.5,1.4,0.8,2.1,0.8L33.2,5c1.7,0.1,3.2,1.3,3.5,2.9l0.8,3.7
	c0.2,0.8,0.6,1.5,1.1,2l2.8,2.6c1.3,1.1,1.6,3,0.8,4.5l-1.8,3.4c-0.4,0.7-0.5,1.5-0.4,2.3l0.5,3.8c0.2,1.7-0.7,3.3-2.3,4l-3.5,1.4
	c-0.7,0.3-1.3,0.8-1.8,1.5l-2,3.2c-0.9,1.4-2.7,2.1-4.3,1.6l-3.6-1.2c-0.7-0.2-1.5-0.2-2.3,0l-3.6,1.2c-1.6,0.5-3.4-0.1-4.3-1.6
	l-2-3.2c-0.4-0.7-1-1.2-1.8-1.5l-3.5-1.4c-1.6-0.6-2.5-2.3-2.3-4l0.5-3.8c0.1-0.8,0-1.6-0.4-2.3l-1.8-3.4c-0.8-1.5-0.5-3.4,0.8-4.5
	l2.8-2.6c0.6-0.5,1-1.2,1.1-2L7.2,8C7.6,6.3,9.1,5.1,10.8,5l3.8-0.1c0.8,0,1.5-0.3,2.1-0.8L19.7,1.8z"
        />

        <path
          d="M18.7078 0.776856C20.057 -0.268999 21.943 -0.268999 23.2922 0.776856L26.2969 3.10606C26.9137 3.58417 27.6645 3.85745 28.4443 3.88765L32.2433 4.03478C33.9491 4.10085 35.3938 5.31316 35.7551 6.98157L36.5597 10.6972C36.7248 11.4599 37.1243 12.1519 37.7023 12.6763L40.5179 15.2309C41.7821 16.378 42.1096 18.2354 41.3139 19.7457L39.5419 23.1092C39.1781 23.7996 39.0394 24.5865 39.1451 25.3597L39.6599 29.1265C39.891 30.8178 38.948 32.4512 37.3677 33.0967L33.8481 34.5342C33.1257 34.8293 32.5136 35.3429 32.0976 36.0031L30.0707 39.2196C29.1606 40.6638 27.3883 41.3088 25.7628 40.7875L22.1426 39.6265C21.3995 39.3881 20.6005 39.3881 19.8574 39.6265L16.2372 40.7875C14.6117 41.3088 12.8394 40.6638 11.9293 39.2196L9.90243 36.0031C9.48638 35.3429 8.8743 34.8293 8.15186 34.5342L4.63234 33.0967C3.05201 32.4512 2.109 30.8178 2.34015 29.1265L2.85493 25.3597C2.9606 24.5865 2.82185 23.7996 2.45811 23.1092L0.686056 19.7457C-0.109628 18.2354 0.217876 16.378 1.48213 15.2309L4.29771 12.6763C4.87566 12.1519 5.27517 11.4599 5.44032 10.6972L6.24489 6.98156C6.60616 5.31316 8.05094 4.10085 9.75673 4.03478L13.5557 3.88765C14.3355 3.85745 15.0863 3.58417 15.7031 3.10606L18.7078 0.776856Z"
          fillOpacity={0.05}
          fill="#232452"
        />
      </g>
      <g fill="none">
        <path
          d="M19.3921 28.8234C19.4712 28.8226 19.537 28.7631 19.544 28.6844C19.6228 27.7961 20.0332 22.7872 19.6963 18.3435C19.286 12.9326 14.5561 12.9652 13.7879 13.0065C13.7228 13.01 13.6731 13.0544 13.6596 13.1182C13.5308 13.7291 12.9214 17.0164 13.3495 22.7684C13.8046 28.8813 17.7296 28.8406 19.3197 28.8241C19.3444 28.8239 19.3685 28.8236 19.3921 28.8234Z"
          className="fill-[#232452]"
        />
        <path
          d="M28.8355 13.1665C28.8353 13.0819 28.767 13.0135 28.6824 13.0135H27.7149C27.2752 13.0135 22.2178 13.0136 21.8662 17.6299C21.8106 18.3602 21.7718 19.1224 21.7456 19.8898C21.7427 19.9763 21.8117 20.048 21.8983 20.048H24.6641C24.6876 20.048 24.7148 20.0483 24.7453 20.0485C25.5703 20.0557 28.8391 20.0841 28.8391 16.0318C28.8391 14.8322 28.8365 13.591 28.8355 13.1665Z"
          className="fill-[#232452]"
        />
        <path
          d="M21.6253 25.4429C21.6253 23.38 23.119 21.8863 25.1819 21.8863C27.2448 21.8863 28.7385 23.38 28.7385 25.4429C28.7385 27.5058 27.2448 28.9995 25.1819 28.9995C23.119 28.9995 21.6253 27.5058 21.6253 25.4429ZM23.326 25.4531C23.326 24.3624 24.1057 23.5623 25.1822 23.5623C26.2586 23.5623 27.0384 24.3624 27.0384 25.4531C27.0384 26.5438 26.2586 27.344 25.1822 27.344C24.1057 27.344 23.326 26.5438 23.326 25.4531Z"
          fillRule="evenodd"
          clipRule="evenodd"
          className="fill-[#232452]"
        />
        <path
          d="M21.6669 20.0482L21.6638 20.0512V20.0482H21.6669Z"
          className="fill-[#232452]"
        />
      </g>

      <defs>
        <filter
          id="filter0_b_11326_519495"
          x="-5.74609"
          y="-6.00732"
          width="53.4922"
          height="53.0073"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood
            floodOpacity="0"
            result="BackgroundImageFix"
          />
          <feGaussianBlur
            in="BackgroundImageFix"
            stdDeviation="3"
          />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_11326_519495"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_11326_519495"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}

export default IconRecoverySealWhite
